var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinUsArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 35,
    viewBox: "0 0 20 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11612 33.899C9.60427 34.3872 10.3957 34.3872 10.8839 33.899L18.8388 25.9441C19.327 25.4559 19.327 24.6645 18.8388 24.1763C18.3507 23.6882 17.5592 23.6882 17.0711 24.1763L10 31.2474L2.92893 24.1763C2.44078 23.6882 1.64932 23.6882 1.16117 24.1763C0.67301 24.6645 0.67301 25.4559 1.16117 25.9441L9.11612 33.899ZM8.75 0V33.0151H11.25V0L8.75 0Z",
    fill: "#4DB8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinUsArrow);
export default __webpack_public_path__ + "static/media/join-us-arrow.b6c2e18197354229d5ed458ad926d7b4.svg";
export { ForwardRef as ReactComponent };